class AboutTimeline extends HTMLElement {
  constructor() {
    super();
    this.tabs = [];
    this.panels = [];
    this.handleClick = this.handleClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-about-timeline-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-about-timeline-panel]'));
    if (!this.tabs.length || this.tabs.length !== this.panels.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.handleClick);
      tab.addEventListener('keydown', this.handleKeydown);
    });
  }

  disconnectedCallback() {
    this.tabs.forEach((tab) => {
      tab.removeEventListener('click', this.handleClick);
      tab.removeEventListener('keydown', this.handleKeydown);
    });
  }

  select(index, focusTab = false) {
    const nextIndex = Math.max(0, Math.min(index, this.tabs.length - 1));

    this.tabs.forEach((tab, tabIndex) => {
      const isActive = tabIndex === nextIndex;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach((panel, panelIndex) => {
      const isActive = panelIndex === nextIndex;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    const activeTab = this.tabs[nextIndex];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    activeTab.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
    if (focusTab) activeTab.focus();
  }

  handleClick(event) {
    const index = this.tabs.indexOf(event.currentTarget);
    if (index !== -1) this.select(index);
  }

  handleKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
    else if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    else if (event.key === 'Home') nextIndex = 0;
    else if (event.key === 'End') nextIndex = this.tabs.length - 1;
    else return;

    event.preventDefault();
    this.select(nextIndex, true);
  }
}

if (!customElements.get('about-timeline')) {
  customElements.define('about-timeline', AboutTimeline);
}

document.querySelectorAll('[data-about-timeline]').forEach((timeline) => {
  if (timeline.tagName.toLowerCase() === 'about-timeline') return;
  const upgradedTimeline = document.createElement('about-timeline');
  Array.from(timeline.attributes).forEach((attribute) => {
    upgradedTimeline.setAttribute(attribute.name, attribute.value);
  });
  while (timeline.firstChild) upgradedTimeline.appendChild(timeline.firstChild);
  timeline.replaceWith(upgradedTimeline);
});
